import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GgMediaWithMobileMediaComponent } from './gg-media-with-mobile-media.component';

@NgModule({
  imports: [CommonModule],
  declarations: [GgMediaWithMobileMediaComponent],
  exports: [GgMediaWithMobileMediaComponent],
})
export class GgMediaWithMobileMediaModule {}
